export default {
  black: '#000000',
  blue200: '#6D8FA4',
  blue300: 'rgba(38, 61, 75, 0.3)',
  blue500: '#263D4B',
  blue50: '#CCE3F1',
  blue600: '#142C3A',
  blue700: '#0C202D',
  blueDeselected: 'rgba(38,61,75, 0.8)',
  blueDisabled: 'rgba(38,61,75, 0.5)',
  blueOpaque: 'rgba(38, 61, 75, 0)',
  blueLight: 'rgb(38, 61, 75, 0.1)',
  cactus500: '#35A38C',
  cactus50: '#C7FAEF',
  cactus800: '#265148',
  copper: '#C17A52',
  cream10: '#FEFBEE',
  cream: '#FCF9EB',
  grey: '#D9D9D9',
  skyGrey: '#f2f4f5',
  greyActive: 'rgba(0, 0, 0, 0.04)',
  greyMedium: '#B9B9B9',
  neutral100: '#E8E6DF',
  neutral200: '#DDDAD1',
  neutral300: '#C7C4BB',
  neutral500: '#9A9890',
  neutral50: '#F1F0EC',
  orange: '#D67347',
  pink300: '#FF8D91',
  pink500: '#EC6166',
  pink50: '#FFE2E3',
  pink800: '#93373A',
  redCopper: '#D77348',
  shadow: 'rgba(12, 32, 45, 0.1)',
  sunshine100: '#FFF1C2',
  sunshine50: '#FEF9EC',
  white: '#FFFFFF',
  whiteShadow: 'rgba(0, 0, 0, 0.15)',
};
